// 15 ALPACA login themes — ported verbatim from
// Alpaca Login Page/alpaca_lims_all_themes (7).html (design-system 6.1).
export interface LoginTheme {
  id: string; name: string; panelLeft: string; panelRight: string;
  accent: string; accentHover: string; accentGlow: string;
  textOnLeft: string; textMutedLeft: string; textDark: string;
  textMuted: string; textFaint: string; inputBorder: string;
  borderStrong: string; inputBg: string; divider: string;
  featureBg: string; featureBorder: string; statusBg: string;
  statusBorder: string; statusText: string; btsoftLogo: string;
  btsoftBg: string; alpacaWrap: string; alpacaBlend: string;
}

export const THEMES: LoginTheme[] = [
  {
    // Office White — clean orange + white, the corporate default.
    // Becomes the application-wide accent for new users (no saved theme).
    // Existing users keep whatever they previously picked.
    "id": "office-white",
    "name": "Office White",
    "panelLeft": "#FFFFFF",
    "panelRight": "#FFFFFF",
    "accent": "#F97316",
    "accentHover": "#EA580C",
    "accentGlow": "rgba(249,115,22,0.14)",
    "textOnLeft": "#1F2937",
    "textMutedLeft": "#6B7280",
    "textDark": "#1F2937",
    "textMuted": "#6B7280",
    "textFaint": "#9CA3AF",
    "inputBorder": "1.5px solid #E5E7EB",
    "borderStrong": "#D1D5DB",
    "inputBg": "#FAFAFA",
    "divider": "#E5E7EB",
    "featureBg": "#FFF7ED",
    "featureBorder": "rgba(249,115,22,0.10)",
    "statusBg": "#F3F4F6",
    "statusBorder": "#E5E7EB",
    "statusText": "#6B7280",
    "btsoftLogo": "grey",
    "btsoftBg": "#FFFFFF",
    "alpacaWrap": "background:transparent;",
    "alpacaBlend": "mix-blend-mode:multiply;"
  },
  {
    "id": "original",
    "name": "Warm Stone",
    "panelLeft": "#FDFCFB",
    "panelRight": "#FFFFFF",
    "accent": "#E8642A",
    "accentHover": "#C4511F",
    "accentGlow": "rgba(232,100,42,0.14)",
    "textOnLeft": "#1E1A16",
    "textMutedLeft": "#8A8079",
    "textDark": "#1E1A16",
    "textMuted": "#8A8079",
    "textFaint": "#B5AFA8",
    "inputBorder": "1.5px solid #EDE9E3",
    "borderStrong": "#D9D3CA",
    "inputBg": "#F7F4F0",
    "divider": "#EDE9E3",
    "featureBg": "#FEF0E8",
    "featureBorder": "rgba(232,100,42,0.10)",
    "statusBg": "#EDE9E3",
    "statusBorder": "#D9D3CA",
    "statusText": "#8A8079",
    "btsoftLogo": "grey",
    "btsoftBg": "#FFFFFF",
    "alpacaWrap": "background:transparent;",
    "alpacaBlend": "mix-blend-mode:multiply;"
  },
  {
    "id": "midnight",
    "name": "Midnight Steel",
    "panelLeft": "#0F172A",
    "panelRight": "#FFFFFF",
    "accent": "#2563EB",
    "accentHover": "#1D4ED8",
    "accentGlow": "rgba(37,99,235,0.22)",
    "textOnLeft": "#F1F5F9",
    "textMutedLeft": "rgba(241,245,249,0.45)",
    "textDark": "#0F172A",
    "textMuted": "#64748B",
    "textFaint": "#94A3B8",
    "inputBorder": "1.5px solid #E2E8F0",
    "borderStrong": "#CBD5E1",
    "inputBg": "#F8FAFC",
    "divider": "rgba(255,255,255,0.08)",
    "featureBg": "rgba(255,255,255,0.06)",
    "featureBorder": "rgba(255,255,255,0.10)",
    "statusBg": "#0F172A",
    "statusBorder": "rgba(255,255,255,0.08)",
    "statusText": "rgba(241,245,249,0.4)",
    "btsoftLogo": "grey",
    "btsoftBg": "#FFFFFF",
    "alpacaWrap": "background:#fff;border-radius:12px;padding:4px;box-shadow:0 2px 8px rgba(0,0,0,0.25);",
    "alpacaBlend": ""
  },
  {
    "id": "carbon",
    "name": "Carbon & Volt",
    "panelLeft": "#111111",
    "panelRight": "#FFFFFF",
    "accent": "#16C77A",
    "accentHover": "#0DAF69",
    "accentGlow": "rgba(22,199,122,0.20)",
    "textOnLeft": "#FFFFFF",
    "textMutedLeft": "rgba(255,255,255,0.40)",
    "textDark": "#1A1A1A",
    "textMuted": "#555555",
    "textFaint": "#999999",
    "inputBorder": "1.5px solid #E0E0E0",
    "borderStrong": "#CCCCCC",
    "inputBg": "#F5F5F5",
    "divider": "rgba(255,255,255,0.07)",
    "featureBg": "rgba(255,255,255,0.04)",
    "featureBorder": "rgba(255,255,255,0.08)",
    "statusBg": "#0A0A0A",
    "statusBorder": "rgba(255,255,255,0.07)",
    "statusText": "rgba(255,255,255,0.3)",
    "btsoftLogo": "grey",
    "btsoftBg": "#FFFFFF",
    "alpacaWrap": "background:#fff;border-radius:12px;padding:4px;box-shadow:0 2px 8px rgba(0,0,0,0.4);",
    "alpacaBlend": ""
  },
  {
    "id": "arctic",
    "name": "Arctic Precision",
    "panelLeft": "#FFFFFF",
    "panelRight": "#FFFFFF",
    "accent": "#0891B2",
    "accentHover": "#0E7490",
    "accentGlow": "rgba(8,145,178,0.18)",
    "textOnLeft": "#0A0A0A",
    "textMutedLeft": "#6B7280",
    "textDark": "#0A0A0A",
    "textMuted": "#6B7280",
    "textFaint": "#9CA3AF",
    "inputBorder": "2px solid #E5E7EB",
    "borderStrong": "#D1D5DB",
    "inputBg": "#FFFFFF",
    "divider": "#E5E7EB",
    "featureBg": "rgba(8,145,178,0.05)",
    "featureBorder": "rgba(8,145,178,0.12)",
    "statusBg": "#F9FAFB",
    "statusBorder": "#E5E7EB",
    "statusText": "#9CA3AF",
    "btsoftLogo": "grey",
    "btsoftBg": "#FFFFFF",
    "alpacaWrap": "background:transparent;",
    "alpacaBlend": "mix-blend-mode:multiply;"
  },
  {
    "id": "crimson",
    "name": "Crimson Lab",
    "panelLeft": "#7F1D1D",
    "panelRight": "#FFFFFF",
    "accent": "#DC2626",
    "accentHover": "#B91C1C",
    "accentGlow": "rgba(220,38,38,0.20)",
    "textOnLeft": "#FEF2F2",
    "textMutedLeft": "rgba(254,242,242,0.55)",
    "textDark": "#1C0505",
    "textMuted": "#78716C",
    "textFaint": "#A8A29E",
    "inputBorder": "1.5px solid #E7E5E4",
    "borderStrong": "#E7E5E4",
    "inputBg": "#FFFFFF",
    "divider": "rgba(255,255,255,0.12)",
    "featureBg": "rgba(255,255,255,0.08)",
    "featureBorder": "rgba(255,255,255,0.14)",
    "statusBg": "#7F1D1D",
    "statusBorder": "rgba(255,255,255,0.10)",
    "statusText": "rgba(254,242,242,0.45)",
    "btsoftLogo": "grey",
    "btsoftBg": "#FFFFFF",
    "alpacaWrap": "background:#fff;border-radius:12px;padding:4px;box-shadow:0 2px 8px rgba(0,0,0,0.25);",
    "alpacaBlend": ""
  },
  {
    "id": "forest",
    "name": "Forest Sage",
    "panelLeft": "#F0FDF4",
    "panelRight": "#FFFFFF",
    "accent": "#16A34A",
    "accentHover": "#15803D",
    "accentGlow": "rgba(22,163,74,0.16)",
    "textOnLeft": "#14532D",
    "textMutedLeft": "#4B7C5C",
    "textDark": "#14532D",
    "textMuted": "#4B7C5C",
    "textFaint": "#86BBAA",
    "inputBorder": "1.5px solid #D1FAE5",
    "borderStrong": "#A7F3D0",
    "inputBg": "#F0FDF4",
    "divider": "#D1FAE5",
    "featureBg": "rgba(22,163,74,0.06)",
    "featureBorder": "rgba(22,163,74,0.14)",
    "statusBg": "#F0FDF4",
    "statusBorder": "#D1FAE5",
    "statusText": "#4B7C5C",
    "btsoftLogo": "grey",
    "btsoftBg": "#FFFFFF",
    "alpacaWrap": "background:transparent;",
    "alpacaBlend": "mix-blend-mode:multiply;"
  },
  {
    "id": "lavender",
    "name": "Lavender Cloud",
    "panelLeft": "#FAF5FF",
    "panelRight": "#FFFFFF",
    "accent": "#7C3AED",
    "accentHover": "#6D28D9",
    "accentGlow": "rgba(124,58,237,0.16)",
    "textOnLeft": "#3B0764",
    "textMutedLeft": "#7E22CE",
    "textDark": "#1E1B4B",
    "textMuted": "#6D28D9",
    "textFaint": "#C4B5FD",
    "inputBorder": "1.5px solid #EDE9FE",
    "borderStrong": "#DDD6FE",
    "inputBg": "#FAF5FF",
    "divider": "#EDE9FE",
    "featureBg": "rgba(124,58,237,0.05)",
    "featureBorder": "rgba(124,58,237,0.12)",
    "statusBg": "#FAF5FF",
    "statusBorder": "#EDE9FE",
    "statusText": "#A78BFA",
    "btsoftLogo": "grey",
    "btsoftBg": "#FFFFFF",
    "alpacaWrap": "background:transparent;",
    "alpacaBlend": "mix-blend-mode:multiply;"
  }  ,
  {
    "id": "deepocean",
    "name": "Deep Ocean",
    "panelLeft": "#0D3349",
    "panelRight": "#FFFFFF",
    "accent": "#00C2CC",
    "accentHover": "#009BA3",
    "accentGlow": "rgba(0,194,204,0.20)",
    "textOnLeft": "#E0F7FA",
    "textMutedLeft": "rgba(224,247,250,0.50)",
    "textDark": "#0D3349",
    "textMuted": "#546E7A",
    "textFaint": "#90A4AE",
    "inputBorder": "1.5px solid #E0E0E0",
    "borderStrong": "#BDBDBD",
    "inputBg": "#F5F9FA",
    "divider": "rgba(255,255,255,0.10)",
    "featureBg": "rgba(0,194,204,0.08)",
    "featureBorder": "rgba(0,194,204,0.18)",
    "statusBg": "#0D3349",
    "statusBorder": "rgba(255,255,255,0.10)",
    "statusText": "rgba(224,247,250,0.45)",
    "btsoftLogo": "grey",
    "btsoftBg": "#FFFFFF",
    "alpacaWrap": "background:#fff;border-radius:12px;padding:4px;box-shadow:0 2px 8px rgba(0,0,0,0.3);",
    "alpacaBlend": ""
  },
  {
    "id": "ember",
    "name": "Ember Dusk",
    "panelLeft": "#1A0A2E",
    "panelRight": "#FFFFFF",
    "accent": "#FF6B35",
    "accentHover": "#E85A25",
    "accentGlow": "rgba(255,107,53,0.22)",
    "textOnLeft": "#FFE8D6",
    "textMutedLeft": "rgba(255,232,214,0.48)",
    "textDark": "#1A0A2E",
    "textMuted": "#6B5B70",
    "textFaint": "#A89AB0",
    "inputBorder": "1.5px solid #E8E0EC",
    "borderStrong": "#D0C4D8",
    "inputBg": "#FBF8FF",
    "divider": "rgba(255,255,255,0.08)",
    "featureBg": "rgba(255,107,53,0.07)",
    "featureBorder": "rgba(255,107,53,0.16)",
    "statusBg": "#1A0A2E",
    "statusBorder": "rgba(255,255,255,0.08)",
    "statusText": "rgba(255,232,214,0.40)",
    "btsoftLogo": "grey",
    "btsoftBg": "#FFFFFF",
    "alpacaWrap": "background:#fff;border-radius:12px;padding:4px;box-shadow:0 2px 8px rgba(0,0,0,0.3);",
    "alpacaBlend": ""
  },
  {
    "id": "matcha",
    "name": "Matcha Cream",
    "panelLeft": "#2D4A3E",
    "panelRight": "#FFFFFF",
    "accent": "#7CB98A",
    "accentHover": "#5EA370",
    "accentGlow": "rgba(124,185,138,0.20)",
    "textOnLeft": "#F0F7F1",
    "textMutedLeft": "rgba(240,247,241,0.50)",
    "textDark": "#1C2E25",
    "textMuted": "#5A7A65",
    "textFaint": "#95B09E",
    "inputBorder": "1.5px solid #D8EAD8",
    "borderStrong": "#B8D4B8",
    "inputBg": "#F4FAF4",
    "divider": "rgba(255,255,255,0.10)",
    "featureBg": "rgba(124,185,138,0.08)",
    "featureBorder": "rgba(124,185,138,0.18)",
    "statusBg": "#2D4A3E",
    "statusBorder": "rgba(255,255,255,0.10)",
    "statusText": "rgba(240,247,241,0.42)",
    "btsoftLogo": "grey",
    "btsoftBg": "#FFFFFF",
    "alpacaWrap": "background:#fff;border-radius:12px;padding:4px;box-shadow:0 2px 8px rgba(0,0,0,0.25);",
    "alpacaBlend": ""
  },
  {
    "id": "neonoir",
    "name": "Neo Noir",
    "panelLeft": "#0A0A0F",
    "panelRight": "#FFFFFF",
    "accent": "#BF5FFF",
    "accentHover": "#A040EE",
    "accentGlow": "rgba(191,95,255,0.22)",
    "textOnLeft": "#F0E6FF",
    "textMutedLeft": "rgba(240,230,255,0.45)",
    "textDark": "#0A0A0F",
    "textMuted": "#5C5070",
    "textFaint": "#9A90A8",
    "inputBorder": "1.5px solid #E8E0F0",
    "borderStrong": "#D0C4E0",
    "inputBg": "#FAF8FF",
    "divider": "rgba(191,95,255,0.15)",
    "featureBg": "rgba(191,95,255,0.07)",
    "featureBorder": "rgba(191,95,255,0.18)",
    "statusBg": "#0A0A0F",
    "statusBorder": "rgba(191,95,255,0.15)",
    "statusText": "rgba(240,230,255,0.38)",
    "btsoftLogo": "grey",
    "btsoftBg": "#FFFFFF",
    "alpacaWrap": "background:#fff;border-radius:12px;padding:4px;box-shadow:0 2px 12px rgba(191,95,255,0.3);",
    "alpacaBlend": ""
  },
  {
    "id": "copper",
    "name": "Copper & Slate",
    "panelLeft": "#2C2C3E",
    "panelRight": "#FFFFFF",
    "accent": "#C87941",
    "accentHover": "#A85F28",
    "accentGlow": "rgba(200,121,65,0.20)",
    "textOnLeft": "#F5EFE6",
    "textMutedLeft": "rgba(245,239,230,0.48)",
    "textDark": "#1C1C2A",
    "textMuted": "#6B6880",
    "textFaint": "#A0A0B8",
    "inputBorder": "1.5px solid #E5E0EC",
    "borderStrong": "#CCC8D8",
    "inputBg": "#F8F7FB",
    "divider": "rgba(255,255,255,0.08)",
    "featureBg": "rgba(200,121,65,0.07)",
    "featureBorder": "rgba(200,121,65,0.16)",
    "statusBg": "#2C2C3E",
    "statusBorder": "rgba(255,255,255,0.08)",
    "statusText": "rgba(245,239,230,0.40)",
    "btsoftLogo": "grey",
    "btsoftBg": "#FFFFFF",
    "alpacaWrap": "background:#fff;border-radius:12px;padding:4px;box-shadow:0 2px 8px rgba(0,0,0,0.28);",
    "alpacaBlend": ""
  },
  {
    "id": "sakura",
    "name": "Sakura Dusk",
    "panelLeft": "#4A1942",
    "panelRight": "#FFFFFF",
    "accent": "#FF7EB3",
    "accentHover": "#E0609A",
    "accentGlow": "rgba(255,126,179,0.20)",
    "textOnLeft": "#FFE8F4",
    "textMutedLeft": "rgba(255,232,244,0.48)",
    "textDark": "#2E0A28",
    "textMuted": "#7A5E74",
    "textFaint": "#B09AAC",
    "inputBorder": "1.5px solid #F0D8EC",
    "borderStrong": "#DCC0D8",
    "inputBg": "#FDF5FB",
    "divider": "rgba(255,255,255,0.10)",
    "featureBg": "rgba(255,126,179,0.07)",
    "featureBorder": "rgba(255,126,179,0.18)",
    "statusBg": "#4A1942",
    "statusBorder": "rgba(255,255,255,0.10)",
    "statusText": "rgba(255,232,244,0.42)",
    "btsoftLogo": "grey",
    "btsoftBg": "#FFFFFF",
    "alpacaWrap": "background:#fff;border-radius:12px;padding:4px;box-shadow:0 2px 8px rgba(0,0,0,0.25);",
    "alpacaBlend": ""
  },
  {
    "id": "glacial",
    "name": "Glacial White",
    "panelLeft": "#E8EEF4",
    "panelRight": "#FFFFFF",
    "accent": "#2E86C1",
    "accentHover": "#1A6FA8",
    "accentGlow": "rgba(46,134,193,0.18)",
    "textOnLeft": "#1A2E3E",
    "textMutedLeft": "#5A7A90",
    "textDark": "#1A2E3E",
    "textMuted": "#5A7A90",
    "textFaint": "#90A8B8",
    "inputBorder": "1.5px solid #D8E4EC",
    "borderStrong": "#B8CCDA",
    "inputBg": "#F5F9FC",
    "divider": "#D0DCE8",
    "featureBg": "rgba(46,134,193,0.06)",
    "featureBorder": "rgba(46,134,193,0.14)",
    "statusBg": "#E0E8F0",
    "statusBorder": "#C8D8E4",
    "statusText": "#5A7A90",
    "btsoftLogo": "grey",
    "btsoftBg": "#FFFFFF",
    "alpacaWrap": "background:transparent;",
    "alpacaBlend": "mix-blend-mode:multiply;"
  },
  {
    "id": "volcanic",
    "name": "Volcanic Ash",
    "panelLeft": "#1C1C1C",
    "panelRight": "#FFFFFF",
    "accent": "#E84545",
    "accentHover": "#C42B2B",
    "accentGlow": "rgba(232,69,69,0.22)",
    "textOnLeft": "#F5F0EE",
    "textMutedLeft": "rgba(245,240,238,0.48)",
    "textDark": "#1C1C1C",
    "textMuted": "#666666",
    "textFaint": "#AAAAAA",
    "inputBorder": "1.5px solid #E5E5E5",
    "borderStrong": "#CCCCCC",
    "inputBg": "#FAFAFA",
    "divider": "rgba(255,255,255,0.07)",
    "featureBg": "rgba(232,69,69,0.06)",
    "featureBorder": "rgba(232,69,69,0.14)",
    "statusBg": "#111111",
    "statusBorder": "rgba(255,255,255,0.07)",
    "statusText": "rgba(245,240,238,0.38)",
    "btsoftLogo": "grey",
    "btsoftBg": "#FFFFFF",
    "alpacaWrap": "background:#fff;border-radius:12px;padding:4px;box-shadow:0 2px 8px rgba(0,0,0,0.30);",
    "alpacaBlend": ""
  }
];
